import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import { useApiGet } from '../../../utils/httpClient';
import { getIntlInfo } from '../../../endpoints/members';

const IntlInfo = () => {
  const { data: intlInfo } = useApiGet(['intl-info'], getIntlInfo);
  if (!intlInfo) {
    return <Typography variant="body1">Loading...</Typography>;
  }
  return (
    <Grid container>
      <Grid item xs={12} textAlign={'center'} padding>
        <Typography variant="subtitle1" gutterBottom sx={{ color: '#3f3f3f' }}>
          P.E.O. was founded on January 21, 1869, by seven students at Iowa
          Wesleyan University in Mount Pleasant, Iowa. This circle of kindred
          spirits – bonded by their enthusiasm for women's opportunities –
          eventually expanded to include women off campus as well.
        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ color: '#3f3f3f' }}>
          P.E.O.—Where women motivate, educate and celebrate women.
        </Typography>
      </Grid>
      <Grid item xs={12} padding textAlign={'center'}>
        <Divider />
      </Grid>
      <Grid item xs={12} padding textAlign={'left'}>
        <Typography variant="body1">
          <b>{'Active Members:'}</b>{' '}
          {intlInfo.active_members.toLocaleString('en-US')}
        </Typography>
        <Typography variant="body1">
          <b>{'Active Chapters:'}</b>{' '}
          {intlInfo.active_chapters.toLocaleString('en-US')}
        </Typography>
        <Typography variant="body1">
          <b>{'New Initiates (Rolling Year):'}</b>{' '}
          {intlInfo.initiates.toLocaleString('en-US')}
        </Typography>
        <Typography variant="body1">
          <b>{'Reinstatements (Rolling Year):'}</b>{' '}
          {intlInfo.reinstatements.toLocaleString('en-US')}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default IntlInfo;
